import Home from './Home'
import StaffDetails from './profile'

const routes = [
  {
    type: 'collapse',
    key: 'home',
    route: '/',
    component: <Home />,
  },
  {
    type: 'collapse',
    key: 'app_todos',
    route: '/:id',
    component: <StaffDetails />,
  }
]

export default routes
